<template>
    <demo-gateway-frame
        demo_route_name="order-confirmation-demo-start"
        hero_icon="mdi-package-variant-closed"
        hero_title="Order Confirmation Experience Demo"
        hero_subtitle="Interactive demonstration of written consent collection during the order confirmation process"
        :business_impact_items="benefits"
        :experience_flow_steps="flow_steps"
        :compliance_items="compliance_items"
    />
</template>

<script>
import DemoGatewayFrame from '@/components/demos/shared/gateway-frame.vue';

export default {
    name: 'OrderConfirmationDemoIntro',

    components: {
        DemoGatewayFrame
    },

    data() {
        return {
            benefits: [
                {
                    icon: 'mdi-trending-up',
                    title: '2.1x Higher Order Attribution',
                    description: 'Research that shows that consumers with consent on file in RedChirp have 2.1x the attributed orders to those who do not'
                },
                {
                    icon: 'mdi-account-check',
                    title: 'Enhanced Customer Trust',
                    description: 'Transparent consent process builds customer confidence and improves long-term relationships'
                },
                {
                    icon: 'mdi-emoticon-happy-outline',
                    title: 'Replace Consent Anxiety with Action',
                    description: 'If you\'re worried about consent, RedChirp provides straightforward flows and documentation so you can act confidently'
                }
            ],
            flow_steps: [
                {
                    number: 1,
                    title: 'Order Placed',
                    description: 'Customer completes purchase and chooses shipping'
                },
                {
                    number: 2,
                    title: 'SMS Notification',
                    description: 'Automated text with secure link to confirm order details'
                },
                {
                    number: 3,
                    title: 'Order Confirmation or Change Request',
                    description: 'Customer verifies details or requests changes, providing express consent along the way'
                }
            ],
            compliance_items: [
                {
                    icon: 'mdi-shield-sync',
                    title: 'May Help Meet Compliance Goals',
                    description: 'Helps you gather consent and provides documentation to support TCPA and applicable state law compliance'
                },
                {
                    icon: 'mdi-file-document-check',
                    title: 'Complete Audit Trail',
                    description: 'Automated documentation of consent collection may reduces risk and ensures records of consent are maintained'
                }
            ]
        }
    },

    mounted() {
        document.title = "Order Confirmation Demo | RedChirp";
    }
}
</script>